import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

function StatusText ({
  children,
  color = 'active',
  subtitle = null,
  bigText = false,
  withStatus = true
}) {
  const colorClassName = classNames(
    { 'bg-available': color === 'active' || color === 'green' },
    { 'bg-gray-300': color === 'inactive' || color === 'gray' },
    { 'bg-red-600': color === 'danger' || color === 'red' },
    { 'bg-yellow-300': color === 'pending' || color === 'yellow' }
  )

  const subtitleElement = subtitle ? <div className={'text-sm text-gray-500 ' + (bigText ? 'mt-2' : 'mt-1')}>{subtitle}</div> : null

  return (
    <div className={withStatus ? 'relative pl-4 leading-4' : 'relative leading-4'}>
      {withStatus ? (<div className={'w-2 h-2 rounded-full absolute top-1 left-0 ' + colorClassName} />) : null}
      <div className={bigText ? 'font-medium' : 'text-sm'}>{children}</div>
      {subtitleElement}
    </div>
  )
}

StatusText.propTypes = {
  color: PropTypes.oneOf([
    'active',
    'inactive',
    'danger',
    'pending',
    'gray',
    'red',
    'green',
    'yellow'
  ]),
  bigText: PropTypes.bool,
  withStatus: PropTypes.bool,
  subtitle: PropTypes.any
}

export default StatusText
